import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Banner } from '@cad-arc';
import { useEsriIdentityCredentialSource } from '../../esri/hooks/use-esri-identity-credential-source';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { useEsriMapStore } from '../hooks/use-esri-map-store';

/**
 * Warns that the map is running without this department's Esri configuration: its credential
 * failed and a shared one is in use, or its webmap is missing and the default basemap is shown.
 */
export const EsriMapConfigurationBanner = observer(
    function EsriMapConfigurationBanner(): React.ReactElement | null {
        const { esriOauthTokenEnabled } = useEnabledFeatures();
        const credentialSource = useEsriIdentityCredentialSource();
        const { isUsingFallbackWebMap } = useEsriMapStore();
        const [isBannerOpen, setIsBannerOpen] = useState(true);

        // Plain 'GLOBAL' is not a failure and stays silent. isUsingFallbackWebMap is only ever
        // set with Esri OAuth on, so it needs no flag check here.
        const hasCredentialFailure =
            esriOauthTokenEnabled && credentialSource === 'GLOBAL_AFTER_DEPARTMENT_FAILURE';

        if ((!hasCredentialFailure && !isUsingFallbackWebMap) || !isBannerOpen) {
            return null;
        }

        return (
            <Banner
                status="attention"
                title="Map Reference Layers Unavailable"
                description="Please contact IT to verify this department's Esri configuration."
                style={{ width: '100%', zIndex: 1 }}
                onClose={() => setIsBannerOpen(false)}
            />
        );
    }
);
